import { BsFacebook } from "react-icons/bs";

import "./Header.css";
const SocialLinks = () => {
  console.log(BsFacebook);

  return (
    <div className="flex">
      <h3 className="hover">@IbrahimSerhane</h3>
      <div className="footer-social-icons">
        <ul className="social-icons">
          <li>
            <a href="# " className="social-icon">
              {" "}
              <i className="fa fa-facebook"></i>
            </a>
          </li>
          <li>
            <a href="# " className="social-icon">
              {" "}
              <i className="fa fa-linkedin"></i>
            </a>
          </li>
          <li>
            <a href="# " className="social-icon">
              {" "}
              <i className="fa fa-github"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SocialLinks;
